import React from 'react';
import { useHistory } from 'react-router-dom';

export const RefreshPage: React.FC = () => {
	const history = useHistory();
	history.goBack();
	return null;
}

export default RefreshPage;